import React, {useEffect, useState} from 'react';
import Property from '@episerver/spa-core/Components/Property';
import Config from 'app/Config';
import TextInput from 'app/Components/Shared/TextInput/TextInput';
import {getCities, SendResumeData} from 'app/Components/Page/CellcomCareersPage/CellcomCareersSlice';
import {useSelector} from 'react-redux';
import {useDispatch} from 'react-redux';
import Autocomplete from 'app/Components/Shared/AutoCompleteInput/AutoCompleteInput';
import {buildUrlAndOpenSameWindow} from 'app/utilities/StringHelpers/StringHelpers';
import CellcomWhiteLogo from './Images/WhiteLogo.png';
import SuccessPage from 'app/Components/Page/CellcomCareersPage/Shared/CareersSubmitSuccess/CareersSubmitSuccess';
import RejectPage from 'app/Components/Page/CellcomCareersPage/Shared/CareersSubmitReject/CareersSubmitReject';
import Loader from 'app/Components/Shared/LocalLoader/LocalLoader';
import {gtag4} from '../../../utilities/analytics/tracking';
import UploadIcon from './Images/upload_cv.svg';
import Image from 'app/Components/Shared/Image/image';


const CareersLandingPage = ({data, context}) => {
    const initialFormData = {
        firstName: '',
        lastName: '',
        city: '',
        email: '',
        phoneNumber: '',
        file: '',
    };

    const [formData, setFormData] = useState(initialFormData);
    const [errors, setErrors] = useState(initialFormData);
    const [currentStep, setCurrentStep] = useState(1);



    const numOfSteps = Object.keys(initialFormData).length;
    const validNameRegex = /^[א-תA-Za-z ."״()-/\'/׳]+$/;
    const allowedFileTypes = ['application/pdf', "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
    const dispatch = useDispatch();
    const {cities, resumeJobStatus} = useSelector((state) => state.cellcomCareers); // adjust the selector accordingly
    const [isMobile, setIsMobile] = useState(window.innerWidth < 767);
    const [btnData, setBtnData] = useState();
    const [submitData, setSubmitData] = useState();
    const [currentPage, setCurrentPage] = useState('init');
    React.useEffect(() => {
        dispatch(getCities());
    }, [dispatch]);

    useEffect(() => {
        function reportWindowSize() {
            setIsMobile(window.innerWidth < 767);
        }

        window.addEventListener('resize', reportWindowSize);

        return () => {
            window.removeEventListener('resize', reportWindowSize);
        };
    }, []);

    useEffect(() => {
        if (resumeJobStatus === 'success') {
            setSubmitData({name: formData.firstName + ' ' + formData.lastName, title: ''});
            setBtnData({buttonSuccesText: 'חזרה לעמוד הראשי', buttonSuccesUrl: Config.basePath});
        } else if (resumeJobStatus === 'rejected') {
            setBtnData({buttonFailedText: 'חזרה לעמוד הראשי', buttonFailedUrl: Config.basePath});
        }
        setCurrentPage(resumeJobStatus);
    }, [resumeJobStatus]);
    const convertParamToName = (param) => {
        switch (param) {
            case 'firstName':
                return 'שם פרטי';
            case 'lastName':
                return 'שם משפחה';
            case 'city':
                return 'עיר';
            case 'email':
                return 'אימייל';
            case 'phoneNumber':
                return 'טלפון';
            case 'file':
                return 'העלו קורות חיים';

            default:
                return '';
        }
    };

    const isValidated = (type, value) => {
        let isValid = true;
        const updatedErrors = {...errors};
        try {
            switch (type) {
                case 'firstName':
                    if (value?.length <= 1 || !validNameRegex.test(value)) {
                        updatedErrors.firstNameError = 'שם פרטי הוא שדה חובה';
                        isValid = false;
                    } else {
                        reportStep('step_first_name', value);
                        delete updatedErrors.firstNameError;
                    }
                    break;
                case 'lastName':
                    if (value?.length <= 1 || !validNameRegex.test(value)) {
                        updatedErrors.lastNameError = 'שם משפחה הוא שדה חובה';
                        isValid = false;
                    } else {
                        reportStep('step_last_name', value);
                        delete updatedErrors.lastNameError;
                    }
                    break;
                case 'phoneNumber':
                    // eslint-disable-next-line no-case-declarations
                    const isValidPhoneNumber =
                        /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/.test(value.trim()) &&
                        /^0(5[0-9]|6[47])(\-)?[^0\D]\d{6}$/.test(value.trim());
                    if (!isValidPhoneNumber) {
                        updatedErrors.phoneNumberError = 'טלפון הוא שדה חובה';
                        isValid = false;
                    } else {
                        reportStep('step_phone', value);
                        delete updatedErrors.phoneNumberError;
                    }
                    break;
                case 'email':
                    if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
                        updatedErrors.email = 'אימייל הוא שדה חובה';
                        isValid = false;
                    } else {
                        reportStep('step_email', value);
                        delete updatedErrors.email;
                    }
                    break;
                case 'file':
                    if (value) {
                        if (!allowedFileTypes.includes(value.type)) {
                            updatedErrors.file = 'סוג קובץ לא נתמך (PDF בלבד)';
                            isValid = false;
                        } else {
                            reportStep('step_cv', value.name);
                            delete updatedErrors.file;
                        }
                    } else {
                        // If no file is provided, clear any previous error messages
                        delete updatedErrors.file;
                    }
                    break;
                case 'city':
                    if (!value) {
                        updatedErrors.city = 'עיר הוא שדה חובה';
                        isValid = false;
                    } else {
                        reportStep('step_city', value);
                        delete updatedErrors.city;
                    }
                    break;
                default:
                    break;
            }
        } catch (e) {
            return isValid;
        }

        setErrors(updatedErrors);
        return isValid;
    };

    const handleChange = (e) => {
        const {name, value, type, files} = e.target;

        if (type === 'file') {
            if (!allowedFileTypes.includes(files[0].type)) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    file: 'אופס הקובץ לא נתמך שננסה לסגור על pdf/docx ?',
                }));
            } else {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    file: '',
                }));
            }
            const fileReader = new FileReader();
            fileReader.onload = (event) => {
                const base64File = event.target.result;
                setFormData((prevData) => ({
                    ...prevData,
                    [name]: {
                        base64: base64File,
                        name: files[0].name,
                        type: files[0].type,
                    },
                }));
            };
            fileReader.readAsDataURL(e.target.files[0]);
        } else {
            if (name === 'city' && cities.length > 0) {
                var selectedCity = cities.find((x) => x.cityCode === value || x.cityName === value);
                setFormData((prevData) => ({
                    ...prevData,
                    [name]: selectedCity ? selectedCity.cityName : value,
                }));
            } else {
                setFormData((prevData) => ({
                    ...prevData,
                    [name]: value,
                }));
            }
        }
    };

    const nextStep = () => {
        const isValid = isValidated(Object.keys(formData)[currentStep - 1], formData[Object.keys(formData)[currentStep - 1]]);
        if (isValid) {
            setCurrentStep((prevStep) => prevStep + 1);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const isValid = Object.keys(formData)
            .filter((key) => key !== 'file') // Exclude the 'file' key
            .every((key) => formData[key] !== '');

        if (!isValid) return;
        if (
            !isValidated('file', formData.file) ||
            !isValidated('city', formData.city) ||
            !isValidated('email', formData.email) ||
            !isValidated('phoneNumber', formData.phoneNumber) ||
            !isValidated('firstName', formData.firstName) ||
            !isValidated('lastName', formData.lastName)
        ) {
            return;
        }
        const {firstName, lastName, email, phoneNumber, file, city} = formData;
        try {
            const pepperData = {
                firstName: firstName,
                lastName: lastName,
                email: email,
                phone: phoneNumber,
                fileName: file.name,
                fileType: file.type,
                fileStream: file.base64,
                city: city,
                jobId: "JB-8934",
                sender: 'LandingPage',
                source: 'Cellcom_Careers_Landing_Page',
            };
            // setSubmitData({name: firstName, jobTitle: title});
            dispatch(SendResumeData(pepperData));
            reportStep('complete_job_submit', true);
        } catch (e) {
            reportStep('complete_job_submit', false);
            return;
        }
    };

    const handleClickBtn = () => {
        buildUrlAndOpenSameWindow(data.btnLink.value);
    };

    const reportStep = (step, value) => {
        gtag4({
            event: `'CellcomLanding_Careers'`,
            action: step,
            content: value,
        });
    };

    switch (currentPage) {
        case 'init':
            return (
                <>
                    <div className={'careers-landingPage__container'}>
                        <Image className='careers-landingPage__image' src={isMobile ? require('./Images/careers_banners_mobile.png') : require('./Images/careers_banners.png')}
                             alt='background'/>
                        <Image className='careers-landingPage__logo' src={CellcomWhiteLogo} alt=''/>
                        <div className={'careers-landingPage__title'}>
                            <Property context={context} iContent={data} field='mainTitle'/>
                        </div>

                        <div className={'careers-landingPage__description'}>
                            <Property context={context} iContent={data} field='subTitle'/>
                            <div className={'careers-landingPage__description__info'}>
                                <Property context={context} iContent={data} field='bottomTitle'/>
                                {/*{data?.btnTitle?.value.length > 0 ?*/}
                                {/*    <button className='careers-landingPage__btnText btn-submit'>*/}
                                {/*        {data?.btnTitle?.value}*/}
                                {/*    </button>*/}
                                {/*    : <></>}*/}
                            </div>
                        </div>

                        <div className={'careers-landingPage__utilJobs'}>
                            {Array.isArray(data?.utilJobs?.value) &&
                                data?.utilJobs?.value.map((job, index) => (
                                    <label className='careers-landingPage__utilJobs__textInfo' key={index}>
                                        {job}
                                    </label>
                                ))}
                        </div>
                        <div className={'careers-landingPage__formsTitle'}>
                            <Property context={context} iContent={data} field='formsTitle'/>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className='careers-landingPage__forms'>
                                {Object.keys(formData).map((key, index) => {
                                    if (index + 1 === currentStep) {
                                        return (
                                            <div key={key}>
                                                {/*<label htmlFor={key} ref={isWrittenRef}>{convertParamToName(key)}:</label>*/}
                                                {key === 'file' ? (
                                                    <div className={'careers-landingPage__forms__file-input'}>
                                                        <label htmlFor='careers-adItem__sendJob__file-input'
                                                               className={`has-float-label `}>
                              <span>
                                <>
                                  {formData.file ? (
                                      <>{formData.file.name}</>
                                  ) : (
                                      <span style={{color: 'black !important', display: 'block'}}>
                                      <Image className={'careers-landingPage__forms__img'} src={UploadIcon}
                                           alt={'icon_upload'}/>{' '}
                                          {convertParamToName(key) + ':'}{' '}
                                    </span>
                                  )}
                                </>
                              </span>
                                                        </label>
                                                        <div className='custom-file-upload'>
                                                            <input
                                                                onChange={(e) => {
                                                                    handleChange(e);
                                                                    document.getElementById('file-name').textContent = e.target.files[0].name;
                                                                }}
                                                                type='file'
                                                                className='text-input'
                                                                name={'file'}
                                                                hidden
                                                                id='careers-adItem__sendJob__file-input'
                                                                onClick={(e) => (e.target.value = null)} // Clear the input value to allow selecting the same file again
                                                            />
                                                        </div>
                                                    </div>
                                                ) : key === 'city' && cities.length > 0 ? (
                                                    <div className={'careers-landingPage__forms__autoComplete'}>
                                                        <Autocomplete
                                                            value={formData.city}
                                                            id={key}
                                                            name={key}
                                                            onSelectedChange={handleChange}
                                                            suggestions={cities}
                                                            dataKey='cityCode'
                                                            dataValue='cityName'
                                                            placeholder='עיר'
                                                        />
                                                    </div>
                                                ) : (
                                                    <TextInput
                                                        type={key === 'email' ? 'email' : 'text'}
                                                        className='text-input'
                                                        id={key}
                                                        name={key}
                                                        maxLength={key === 'phoneNumber' ? 10 : null}
                                                        value={formData[key]}
                                                        onChange={handleChange}
                                                        required
                                                        placeholder={convertParamToName(key)}
                                                    />
                                                )}
                                            </div>
                                        );
                                    }
                                    return null;
                                })}

                                {currentStep !== Object.keys(formData).length && (
                                    <button type='button' onClick={nextStep}>
                                        הבא
                                    </button>
                                )}
                                <div>{currentStep === Object.keys(formData).length &&
                                    <button type='submit'>שלח</button>}</div>

                                <div>
                  <span className={'careers-landingPage__progressStep'}>
                    {currentStep}/{numOfSteps}
                  </span>
                                </div>
                            </div>
                        </form>
                        <div></div>
                        <div className={'careers-landingPage__error'}>
                            {Object.values(errors).map((errValue, index) => {
                                return (
                                    errValue.length > 0 && (
                                        <span key={index} style={{color: 'red'}}>
                      {errValue}
                    </span>
                                    )
                                );
                            })}
                        </div>
                    </div>
                </>
            );
        case 'success':
            return <SuccessPage context={context} submitData={submitData} buttonData={btnData}/>;
        case 'rejected':
            return <RejectPage context={context} buttonData={btnData}/>;
        case 'pending':
            return <>
                <div className={'careers-landingPage__error'}>
                    <p>אנא המתינו בזמן שהנתונים נבדקים</p>
                    <Loader/>;
                </div>
            </>
        default:
            return <></>;
    }
};

export default CareersLandingPage;
